var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.25C1 10.25 4.69206 3 11.1532 3C17.6143 3 21.3063 10.25 21.3063 10.25C21.3063 10.25 17.6143 17.5 11.1532 17.5C4.69206 17.5 1 10.25 1 10.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1532 12.9688C12.6825 12.9688 13.9222 11.7515 13.9222 10.25C13.9222 8.74848 12.6825 7.53125 11.1532 7.53125C9.62387 7.53125 8.38413 8.74848 8.38413 10.25C8.38413 11.7515 9.62387 12.9688 11.1532 12.9688Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e853796a12dea366742f1d09489c18aa.svg";
export { ForwardRef as ReactComponent };